<div class="content">
    <h4>Atualização de Anúncios</h4>
    <div class="text-content">
        <textarea nz-input #inp [(ngModel)]="texto"> </textarea>
    </div>
    <div class="pb-content">
        <nz-progress [nzPercent]="value" nzStatus="active" [nzShowInfo]="true"></nz-progress>
    </div>
    <div class="button-content">
        <div class="spacer"></div>
        <span><button nz-button nzType="primary" (click)="sair()" [disabled]="disabled">Sair</button></span>
    </div>
</div>
